import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { Context } from '@grandvisionhq/carts-v2';
import { Button } from '@grandvisionhq/common';
import { Divider } from '@grandvisionhq/elements';
import { Form, FormGroup } from '@grandvisionhq/forms';
import { createSlotsContext } from '@grandvisionhq/slots';
import { useIntl } from '@grandvisionhq/state';

const [FormSlotsProvider, useBaseFormSlot] = createSlotsContext({
    displayName: 'FormSlotsContext'
});
const useIsFormSlotAvailable = (formName)=>{
    const { Slots  } = useBaseFormSlot();
    return Boolean(Slots[formName]);
};
const useFormSlotWithoutRedux = (props)=>{
    var ref, ref1, ref2, ref3, ref4;
    const { Slots  } = useBaseFormSlot();
    const cartContext = React.useContext(Context.CartContext);
    const { getLabel  } = useIntl();
    const cartContainsContactLenses = cartContext === null || cartContext === void 0 ? void 0 : (ref = cartContext.cart) === null || ref === void 0 ? void 0 : ref.contains.contactLenses;
    const cartContainsSolutions = cartContext === null || cartContext === void 0 ? void 0 : (ref1 = cartContext.cart) === null || ref1 === void 0 ? void 0 : ref1.contains.solutions;
    const cartContainsPrescriptionGlasses = cartContext === null || cartContext === void 0 ? void 0 : (ref2 = cartContext.cart) === null || ref2 === void 0 ? void 0 : ref2.contains.prescriptionGlasses;
    const cartContainsSunglasses = cartContext === null || cartContext === void 0 ? void 0 : (ref3 = cartContext.cart) === null || ref3 === void 0 ? void 0 : ref3.contains.sunglasses;
    const cartContainsSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref4 = cartContext.cart) === null || ref4 === void 0 ? void 0 : ref4.contains.subscription;
    const handleChange = React.useCallback((formData)=>{
        (props === null || props === void 0 ? void 0 : props.onChange) && (props === null || props === void 0 ? void 0 : props.onChange(formData));
    }, [
        props
    ]);
    const debouncedHandleChange = React.useMemo(()=>{
        return debounce(200, handleChange);
    }, [
        handleChange
    ]);
    const forms = Object.entries(Slots).reduce((formItem, [key, Slot])=>{
        const formData = (props === null || props === void 0 ? void 0 : props.formInitialData[key]) ? props === null || props === void 0 ? void 0 : props.formInitialData[key] : undefined;
        formItem[key] = /*#__PURE__*/ React.createElement(Form, {
            name: key,
            "data-t": key,
            initialFormState: formData,
            onChange: debouncedHandleChange,
            ref: props === null || props === void 0 ? void 0 : props.formRef,
            onSubmit: props === null || props === void 0 ? void 0 : props.onSubmit,
            className: props === null || props === void 0 ? void 0 : props.className
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "form-content__fields"
        }, /*#__PURE__*/ React.createElement(Slot, {
            cartContainsContactLenses: cartContainsContactLenses,
            cartContainsSolutions: cartContainsSolutions,
            cartContainsSunglasses: cartContainsSunglasses,
            cartContainsSubscription: cartContainsSubscription,
            cartContainsPrescriptionGlasses: cartContainsPrescriptionGlasses,
            disableFields: props === null || props === void 0 ? void 0 : props.disableFields
        })), Boolean(props === null || props === void 0 ? void 0 : props.onSubmit) ? /*#__PURE__*/ React.createElement("div", {
            className: "form-content__footer"
        }, /*#__PURE__*/ React.createElement(Divider, {
            className: "form-content__footer-divider"
        }), /*#__PURE__*/ React.createElement(FormGroup, null, /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('common.actions.cancel'),
            "aria-label": getLabel('common.actions.cancel'),
            onClick: props === null || props === void 0 ? void 0 : props.onCancel,
            variant: "outline"
        }), /*#__PURE__*/ React.createElement(Button, {
            type: "submit",
            variant: "solid",
            "aria-label": getLabel('common.actions.save'),
            caption: getLabel('common.actions.save')
        }))) : null));
        return formItem;
    }, {});
    return forms;
};

export { FormSlotsProvider, useBaseFormSlot, useFormSlotWithoutRedux, useIsFormSlotAvailable };
//# sourceMappingURL=form-context.js.map
